import { AddressType } from '@ukpostbox/client-data';
import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	FormWrapperLabel,
} from '@ukpostbox/frontend-framework';
import { Controller, useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { memo, useCallback, useEffect } from 'react';
import { useSendMail } from '../../../Providers/SendMailProvider';
import { AddAddressTypeButtons } from '../../../../_Global/Components/Address/AddAddress/AddAddressTypeButtons';

type SendsAddressControlType = {
	allowCreateAddress?: boolean;
	addAddressCallback?: (address: AddressType) => void;
	addBulkAddressCallback?: (addresses: Array<AddressType>) => void;
};

const RestrictedAddressControl = memo((props: SendsAddressControlType) => {
	const { control, setValue } = useFormContext();
	const { reset, address, addressOptions, sendPageID, UpdateAddress } = useSendMail();

	const UpdateSelectedAddress = useCallback(() => {
		if (address) {
			setValue('address', address.id);
		} else if (addressOptions && addressOptions.length === 1) {
			setValue('address', addressOptions[0].value);
		} else {
			setValue('address', -1);
		}
	}, [addressOptions]);

	useEffect(() => {
		UpdateSelectedAddress();
	}, [reset, sendPageID, addressOptions]);

	return (
		<>
			<Controller
				control={control}
				name='address'
				rules={{ required: true, validate: (value) => (value === -1 ? 'Address Selection is required' : true) }}
				render={({ field, fieldState }) => (
					<FormWrapperLabel label='Address' validationMessage={fieldState.error?.message}>
						{addressOptions.length > 1 ? (
							<ComboBoxControl
								valueType='number'
								name='address'
								placeholder='Select Address...'
								forwardValueCallback={(e) => {
									field.onChange(e);
									UpdateAddress(e);
								}}
								defaultValue={[field.value]}
								data={addressOptions}
								displayType={ComboBoxTypeEnum.Single}
								displayItemLabelType={ComboBoxItemDisplayEnum.Label}
							/>
						) : (
							<input
								readOnly
								value={addressOptions.length === 0 ? 'Use Envelope Window' : addressOptions[0].label}
							/>
						)}
					</FormWrapperLabel>
				)}
			/>

			{props.allowCreateAddress && (
				<AddAddressTypeButtons
					name='addAddressControls'
					addressAddedCallback={(addedAddress) =>
						props.addAddressCallback ? props.addAddressCallback(addedAddress) : null
					}
					vcfImportedCallback={(vcfAddresses) =>
						props.addBulkAddressCallback ? props.addBulkAddressCallback(vcfAddresses) : null
					}
					csvImportedCallback={(csvAddresses) =>
						props.addBulkAddressCallback ? props.addBulkAddressCallback(csvAddresses) : null
					}
				/>
			)}
		</>
	);
});

export { RestrictedAddressControl };
